/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SysqueRadioButtonVM } from '../../models/sysque-radio-button-vm';

@Component({
  selector: 'sysque-radio-button-options-line',
  templateUrl: './sysque-radio-button-options-line.component.html',
  styleUrls: ['./sysque-radio-button-options-line.component.scss'],
  standalone: false
})
export class SysqueRadioButtonOptionsLineComponent implements OnInit {
  @Input() label: string;
  @Input() radioGroupItems: SysqueRadioButtonVM[];
  @Output() valueChanged = new EventEmitter<string>();

  items = [];
  value = '';

  ngOnInit(): void {
    for (let value of this.radioGroupItems) {
      this.items.push(value.label);
    }
    this.value = this.radioGroupItems.find(x => x.isChecked)?.label;
  }

  onValueChanged($event: string) {
    this.value = $event;
    this.valueChanged.emit($event);
  }
}
